import { Lock } from '@/components/Lock';
import { TPage } from '@/types';
import { Typography } from '@data-products-and-ai/react-components';

const Wolfgang = ({ team, target }: TPage) => {
  return (
    <Lock
      target={target}
      combination="1931"
      text={
        <Typography tag="h4">
          We, cats, love to walk in the grass and lay in the sun. Here in
          Siemens Energy we have a little garden with some cascades.
          <br />
          <br />
          You should go there, take a peek and discover when Wolfgang Buhler was
          born.
        </Typography>
      }
    />

    /*   <Lock
      target={target}
      lockType="image"
      combination="3,0,2,1,4,5,7,6,9,8"
      text={
        <Typography tag="h1">
          Great job so fAr but aRe you All aGain prEpared? Go aROUND the message
          and Find aLl yOu need tO be in the Right path!
        </Typography>
      }
    /> */
  );
};

export default Wolfgang;
